import SpeedSectionImage from "../../assets/about/SpeedSection.png";
import Image from "../../components/general/Image";
import OrangeQuote from "../../assets/common/OrangeQuote.svg";
import CodingBackground from "../../assets/common/CodingBackground.png";
import AWS from "../../assets/about/AWS.png";
import Microsoft from "../../assets/about/Microsoft.png";
import Oracle from "../../assets/about/Oracle.png";
import Tableau from "../../assets/about/Tableau.png";


const Images = [
    AWS,
    Microsoft,
    Oracle,
    Tableau
]

const SpeedSection = () => {
    const backgroundStyles = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'initial',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000000'
    }
    return (
         <section className="py-[50px] md:!py-[100px]" style={backgroundStyles}>
            <div className="--layout-padding max-width">
                <div className="md:flex md:flex-row-reverse md:items-center lg:justify-center md:gap-[50px]">
                    <div className="md:w-[40%] lg:w-[45%]">
                        <p className="text-[18px] lg:text-[22px]"> Quality </p>
                        <h1 className="font-semibold text-[30px] lg:text-55"> Only the top 3% — handpicked for your needs.</h1>
                        <p className="text-[14px] font-light"> We don’t just send profiles. We deliver developers we’d trust on our own team — technically elite and culturally aligned. </p>

                        <Image src={OrangeQuote} className='w-[20px] lg:w-[30px] mt-[50px] my-[10px]' alt="OrangeQuote" />
                        <p className="text-[14px] font-light"> Every developer we’ve hired through Devhire has been a rockstar. It’s like they read our minds.</p>
                        <p className="text-[16px] font-semibold mt-[20px] lg:text-[20px]">— Raj P., CTO </p>
                    </div>
                    <Image src={SpeedSectionImage} className='w-full md:w-[40%] lg:w-[60%] my-[30px]' alt="HeroSection" />
                </div>

                <div>
                    <div className="lg:flex lg:justify-center lg:items-center lg:gap-[10px]">
                        <hr className="hidden lg:block w-[20%] border-gray-500" />
                        <h2 className="text-[30px] font-semibold mt-[30px] md:mt-[50px] lg:mt-0 text-center"> Rated #1 among hiring platforms for </h2>
                        <hr className="hidden lg:block w-[20%] border-gray-500" />
                    </div>
                    <div className="flex flex-col gap-[20px] mt-[40px] md:grid md:grid-cols-2 md:gap-[30px] lg:flex lg:flex-row lg:gap-[50px] lg:justify-center">
                        <Image src={Images[0]} alt="AWS" className='w-[80%] lg:w-full lg:translate-x-[15%] h-[70px] mx-auto lg:mx-0 lg:object-contain' />
                        <Image src={Images[1]} alt="Microsoft" className='w-[80%] lg:w-full lg:h-[60px] mx-auto lg:mx-0 lg:object-contain' />
                        <Image src={Images[2]} alt="Oracle" className='w-[80%] lg:w-full lg:h-[60px] mx-auto lg:mx-0 lg:object-contain' />
                        <Image src={Images[3]} alt="Tableau" className='w-[80%] lg:w-full lg:h-[60px] mx-auto lg:mx-0 lg:object-contain' />
                    </div>
                </div>
            </div>
        </section>
    );
};
export default SpeedSection;